export default __webpack_public_path__ + "static/media/valentine.97bb7696.jpg";